export default __webpack_public_path__ + "static/media/double-single-border-right.57f7940e.svg";